import React from "react";

const Groups = () => {
  return <div>Grupos</div>;
};

export default Groups;
